import React, {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core";
import styles from "../styles";
import {hoverPoi} from "../../../store/district";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Tooltip from "@material-ui/core/Tooltip";

const ImgPoi = ({
	classes,
	poi,
	originalWidth,
	originalHeight,
	currentWidth,
	currentHeight
}) => {
	const dispatch = useDispatch();
	const {hoverId} = useSelector(state => state.district);
	const [hoveredPoi, setHoverPoi] = useState(hoverId);
	const [xCordinat, setXCordinat] = useState(poi.xCoordinate);
	const [yCordinat, setYCordinat] = useState(poi.yCoordinate);

	useEffect(() => {
		if (originalWidth && originalHeight && currentWidth && currentHeight) {
			const differenceWidth = (originalWidth - currentWidth) / 2;
			const differenceHeight = (originalHeight - currentHeight) / 2;
			setXCordinat(poi.xCoordinate - differenceWidth);
			setYCordinat(poi.yCoordinate - differenceHeight);
		}
	}, [originalWidth, originalHeight, currentWidth, currentHeight]);
	useEffect(() => {
		setHoverPoi(hoverId);
	}, [hoverId]);
	return (
		<>
			{originalWidth && originalHeight &&
			poi.images.length ?
				<Link className={classes.poiList} to={`/district/${poi.id}`}>
					<div
						onMouseEnter={() => dispatch(hoverPoi(poi.id))}
						onMouseLeave={() => dispatch(hoverPoi(null))}
						className={`${classes.poiInImg} ${hoveredPoi === poi.id &&
						"active-poi"}`}
						style={{
							position: "absolute",
							left: `${xCordinat}px`,
							top: `${yCordinat}px`
						}}
					>
						<VisibilityIcon/>
					</div>
				</Link> : <Tooltip title={<h2>{poi.title}</h2>} arrow enterTouchDelay={100}>
					<div
						onMouseEnter={() => dispatch(hoverPoi(poi.id))}
						onMouseLeave={() => dispatch(hoverPoi(null))}
						className={`${classes.poiInImg} ${hoveredPoi === poi.id &&
						"active-poi"}`}
						style={{
							position: "absolute",
							left: `${xCordinat}px`,
							top: `${yCordinat}px`
						}}
					>
						<VisibilityIcon/>
					</div>
				</Tooltip>
			}
		</>
	);
}
;
export default withStyles(styles)(ImgPoi);
